/**
 * ReportsHarvestInspectionsPeopleTable Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectReportsHarvestInspectionsPeopleArray } from '../../../../../../services/reportsHarvestInspectionsPeople/selectors';

// Workspaces
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
} from '../../../../../../workspaces/react-router-selectors';

// Utils
import orderBy from '../../../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectDataLength = createDeepEqualSelector(
    selectReportsHarvestInspectionsPeopleArray,
    reportsHarvestInspectionsPeopleArrayState =>
        reportsHarvestInspectionsPeopleArrayState.length
);

const selectOrderedData = createDeepEqualSelector(
    [
        selectReportsHarvestInspectionsPeopleArray,
        makeSelectQueryStringValue('people_sort')
    ],
    (
        reportsHarvestInspectionsPeopleArrayState,
        sortState = 'pickerFaultPercentage_descending'
    ) => {
        const attributes = sortState.split('_');
        const propertyName = attributes[0];
        const order = attributes[1] !== 'descending' ? 'asc' : 'desc';

        return orderBy(
            reportsHarvestInspectionsPeopleArrayState,
            propertyName,
            order
        );
    }
);

const selectPaginatedData = createDeepEqualSelector(
    [
        selectOrderedData,
        makeSelectQueryStringNumberValue('people_page'),
        makeSelectQueryStringNumberValue('people_count')
    ],
    (orderedDataState, pageState = 1, countState = 5) => {
        const begin = (pageState - 1) * countState;
        const end = pageState * countState;
        return orderedDataState.slice(begin, end);
    }
);

const selectIds = createDeepEqualSelector(
    selectPaginatedData,
    paginatedDataState =>
        paginatedDataState && paginatedDataState.map(value => value.personId)
);

export { selectDataLength, selectOrderedData, selectIds };
